import { ILanguageItem, MainHeader, MiniHeader } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import Config from '../Config';
import { SSO_HEADER_INCLUDED_PAGES } from '../Routes';
import { ALLOWED_LANGUAGES, Language } from '../stores/LanguageStore';
import useStores from '../stores/UseStores';

const SsoHeader = observer((): React.JSX.Element | null => {
  const {
    translateStore: { translate },
    languageStore,
    routeStore,
  } = useStores();

  const shouldShowMiniHeader = (): boolean => {
    return window.top === window && SSO_HEADER_INCLUDED_PAGES.includes(routeStore.pathname);
  };

  const handleLangClick = (locale: string, event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    routeStore.setLanguage(locale as Language);
  };

  const languageItems = (): ILanguageItem[] => {
    const languagesToShow = ALLOWED_LANGUAGES.filter((allowedLanguage) => allowedLanguage !== languageStore.currentLanguage);

    return languagesToShow.map((locale) => ({
      label: translate(`header.lang.${locale}`),
      url: routeStore.formForwardParamsAnd({ locale }, ['locale']),
      onClick: (e) => handleLangClick(locale, e),
    }));
  };

  if (!shouldShowMiniHeader()) {
    return null;
  }

  return (
    <MainHeader>
      <MiniHeader
        logo={{ text: routeStore.decodedParams?.app || 'Telia' }}
        languages={languageItems()}
        skipLinks={[
          {
            label: translate('header.skiplinks.mainContent'),
            url: '#main-content',
          },
          {
            label: translate('header.skiplinks.accessibility.label'),
            url: `${Config.teliaWebUrl}${translate('header.skiplinks.accessibility.path')}`,
          },
        ]}
      />
    </MainHeader>
  );
});

export default SsoHeader;
